// Pure helpers for kiosk check-in add-on offers. The gap is a moving target —
// receptionists shuffle blockouts all day — so selections are re-validated
// against a fresh gap right before check-in, not just at load.

export function filterOfferableAddOns(addons, bookedServices, gapMinutes) {
  const bookedIds = new Set((bookedServices || []).map(s => s.id));
  return (addons || []).filter(a =>
    !bookedIds.has(a.id) && a.duration > 0 && a.duration <= gapMinutes
  );
}

export function trimSelectionToGap(selectedIds, addons, gapMinutes) {
  const kept = [];
  let used = 0;
  for (const id of selectedIds || []) {
    const a = (addons || []).find(x => x.id === id);
    if (!a) continue;
    if (used + a.duration <= gapMinutes) {
      kept.push(id);
      used += a.duration;
    }
  }
  return kept;
}
